/* Maddie Dance Party — global interactions
   Vanilla JS, no dependencies. Used by both the Liquid theme and the static preview. */
(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var scrim = header.querySelector(".nav-scrim");
    function close() { header.classList.remove("is-open"); }
    // Bind every hamburger (main header + compact scroll bar)
    document.querySelectorAll(".nav-toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        header.classList.toggle("is-open");
      });
    });
    if (scrim) scrim.addEventListener("click", close);
    header.querySelectorAll(".site-nav a").forEach(function (a) {
      a.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.key === "Esc") close();
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero() {
    document.querySelectorAll("[data-hero]").forEach(function (hero) {
      var track = hero.querySelector(".hero__track");
      var slides = hero.querySelectorAll(".hero__slide");
      var dots = hero.querySelectorAll(".hero__dot");
      if (!track || slides.length < 2) return;
      var i = 0;
      var auto = parseInt(hero.getAttribute("data-autoplay") || "0", 10);
      var timer;

      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = "translateX(-" + i * 100 + "%)";
        dots.forEach(function (d, di) {
          d.setAttribute("aria-current", di === i ? "true" : "false");
        });
      }
      dots.forEach(function (d, di) {
        d.addEventListener("click", function () { go(di); restart(); });
      });
      var prevBtn = hero.querySelector("[data-hero-prev]");
      var nextBtn = hero.querySelector("[data-hero-next]");
      if (prevBtn) prevBtn.addEventListener("click", function () { go(i - 1); restart(); });
      if (nextBtn) nextBtn.addEventListener("click", function () { go(i + 1); restart(); });
      function restart() {
        if (!auto) return;
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, auto);
      }
      go(0);
      restart();
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gal) {
      var main = gal.querySelector("[data-gallery-main]");
      var thumbs = gal.querySelectorAll("[data-gallery-thumb]");
      if (!main) return;
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          var src = t.getAttribute("data-src");
          if (src) main.src = src;
          thumbs.forEach(function (x) { x.classList.remove("is-active"); });
          t.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (qty) {
      var input = qty.querySelector("input");
      var dec = qty.querySelector("[data-qty-dec]");
      var inc = qty.querySelector("[data-qty-inc]");
      function clamp(v) { v = parseInt(v, 10); return isNaN(v) || v < 1 ? 1 : v; }
      if (dec) dec.addEventListener("click", function () { input.value = clamp(input.value) - 1 || 1; input.value = Math.max(1, clamp(input.value)); });
      if (inc) inc.addEventListener("click", function () { input.value = clamp(input.value) + 1; });
      if (input) input.addEventListener("change", function () { input.value = clamp(input.value); });
    });
  }

  /* ---------- Floating mini-header on scroll ---------- */
  function initMiniHeader() {
    var mini = document.querySelector("[data-mini-header]");
    var header = document.querySelector(".site-header");
    if (!mini || !header) return;
    var section = header.closest(".shopify-section") || header;
    var ticking = false, shown = false, trigger = 0;
    function measure() { trigger = section.offsetTop + section.offsetHeight; }
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var next = shown ? y > trigger - 80 : y > trigger;
      if (next !== shown) {
        shown = next;
        mini.classList.toggle("is-visible", shown);
        mini.setAttribute("aria-hidden", shown ? "false" : "true");
      }
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener("resize", function () { measure(); update(); }, { passive: true });
    measure(); update();
  }

  /* ---------- Favorites (login-free wishlist via localStorage) ---------- */
  var FAV_KEY = "vp_favorites";
  function favRead() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; }
    catch (e) { return []; }
  }
  function favWrite(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
    favUpdateBadges();
  }
  function favHas(handle) {
    return favRead().some(function (it) { return it.handle === handle; });
  }
  function favToggle(item) {
    var list = favRead();
    var idx = -1;
    list.forEach(function (it, i) { if (it.handle === item.handle) idx = i; });
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(item); }
    favWrite(list);
    return idx === -1;
  }
  function favRemove(handle) {
    favWrite(favRead().filter(function (it) { return it.handle !== handle; }));
  }
  function favUpdateBadges() {
    var n = favRead().length;
    document.querySelectorAll("[data-fav-link]").forEach(function (link) {
      var badge = link.querySelector(".fav-badge");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "fav-badge";
        link.appendChild(badge);
      }
      badge.textContent = n;
      badge.hidden = n === 0;
    });
  }
  function initFavToggles() {
    document.querySelectorAll("[data-fav-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-handle");
      if (!handle) return;
      if (favHas(handle)) { btn.classList.add("is-fav"); btn.setAttribute("aria-pressed", "true"); }
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = favToggle({
          handle: handle,
          title: btn.getAttribute("data-title") || "",
          url: btn.getAttribute("data-url") || ("/products/" + handle),
          image: btn.getAttribute("data-image") || "",
          price: btn.getAttribute("data-price") || ""
        });
        btn.classList.toggle("is-fav", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    });
  }
  function initFavPage() {
    var grid = document.querySelector("[data-fav-grid]");
    if (!grid) return;
    var empty = document.querySelector("[data-fav-empty]");
    function render() {
      var list = favRead();
      grid.innerHTML = "";
      if (!list.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      grid.hidden = false;
      if (empty) empty.hidden = true;
      list.forEach(function (it) {
        var card = document.createElement("div");
        card.className = "fav-card";
        var media = document.createElement("div");
        media.className = "fav-card__media";
        var a = document.createElement("a");
        a.href = it.url || "#";
        if (it.image) {
          var img = document.createElement("img");
          img.src = it.image; img.alt = it.title || ""; img.loading = "lazy";
          a.appendChild(img);
        }
        media.appendChild(a);
        var rm = document.createElement("button");
        rm.type = "button";
        rm.className = "fav-card__remove";
        rm.setAttribute("aria-label", "Remove from favorites");
        rm.textContent = "×";
        rm.addEventListener("click", function () { favRemove(it.handle); render(); });
        media.appendChild(rm);
        card.appendChild(media);
        var name = document.createElement("a");
        name.href = it.url || "#";
        name.style.color = "inherit";
        var p = document.createElement("p");
        p.className = "fav-card__name";
        p.textContent = it.title || "";
        name.appendChild(p);
        card.appendChild(name);
        if (it.price) {
          var price = document.createElement("p");
          price.className = "fav-card__price";
          price.textContent = it.price;
          card.appendChild(price);
        }
        grid.appendChild(card);
      });
    }
    render();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initNav();
    initHero();
    initGallery();
    initQty();
    initMiniHeader();
    initFavToggles();
    initFavPage();
    favUpdateBadges();
  });
})();
